import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { signIn } from "../lib/auth";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await signIn(email, password); toast.success("Bem-vindo!"); navigate("/admin"); }
    catch (err) { toast.error(err.message || "Erro ao fazer login"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream relative overflow-hidden p-5">
      <div className="absolute inset-0 bg-stripes-blue-soft opacity-40" />
      <div className="relative w-full max-w-md">
        <div className="frame-scallop"><div className="frame-inner p-8 md:p-10">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" style={{ background: "var(--ff-peach)" }}><Lock className="text-white" size={28} /></div>
            <h1 className="title-pop text-3xl md:text-4xl mb-2" style={{ color: "var(--ff-text)" }}>Painel Admin</h1>
            <p className="font-body text-sm" style={{ color: "var(--ff-text-soft)" }}>Fantastic Fun</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div><label className="ff-label">Email</label><input type="email" className="ff-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@fantasticfun.pt" required /></div>
            <div><label className="ff-label">Palavra-passe</label><input type="password" className="ff-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required /></div>
            <button type="submit" disabled={loading} className="ff-btn ff-btn-primary w-full" data-testid="admin-login-submit">{loading ? <Loader2 className="animate-spin mr-2" size={18} /> : null}Entrar</button>
          </form>
        </div></div>
      </div>
    </div>
  );
}
